import { useEffect, useState } from "react";
import api from "@/lib/api";
import StatusBadge from "@/components/app/StatusBadge";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/admin/audit-logs", { params: { limit: 200 } }).then(({ data }) => setRows(data.items || [])).catch(() => setRows([]));
  }, []);

  return (
    <div className="space-y-4 max-w-[1600px]">
      <div>
        <div className="text-[10px] font-semibold tracking-[0.08em] uppercase text-slate-500">Intelligence</div>
        <h1 className="text-2xl font-heading font-semibold text-slate-900 tracking-tight">Audit Trail</h1>
        <p className="text-sm text-slate-500 mt-0.5">Immutable record of every action across the platform.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50">
            <tr className="text-[10px] uppercase text-slate-500">
              <th className="px-3 py-2 text-left">Timestamp</th>
              <th className="px-3 py-2 text-left">User</th>
              <th className="px-3 py-2 text-left">Role</th>
              <th className="px-3 py-2 text-left">Action</th>
              <th className="px-3 py-2 text-left">Module</th>
              <th className="px-3 py-2 text-left">Record</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-3 py-2 text-xs text-slate-500 font-mono">{new Date(r.timestamp).toLocaleString()}</td>
                <td className="px-3 py-2 text-xs">{r.user_email || "—"}</td>
                <td className="px-3 py-2 capitalize text-xs">{r.role?.replace(/_/g, " ")}</td>
                <td className="px-3 py-2"><StatusBadge value={r.action} /></td>
                <td className="px-3 py-2 capitalize text-xs">{r.module}</td>
                <td className="px-3 py-2 font-mono text-xs">{r.record_id ? r.record_id.slice(0, 8) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
